import UserRoles from '@/constants/user/roles';

export default {
    path: '/settings',
    name: 'Settings',
    meta: {
        title: 'Settings',
        documentTitle: 'Settings',
        requiresAuth: true,
        mdiIcon: 'settings',
        shouldPersistBetweenLogins: true,
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.PERMISSION_ADMINISTRATOR,
            UserRoles.MAIL_ADMINISTRATOR,
            UserRoles.INVENTORY_ADMINISTRATOR,
        ],
    },
    component: () => import( /* webpackChunkName: "Settings" */ '@/views/Settings' ),
};
